import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestBudget, setPopupState } from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import RequestBudgetService from '../../services/RequestBudgetService';
import { PopupState, PromotionStatus, UnitStatus } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const RequestBudgetPopup = () => {
    const { settings, currentUnit } = useSelector(state => state.configurator);
    const requestBudgetMutation = RequestBudgetService();
    const dispatch = useDispatch();

    const isBudgetRequestAvailable = () => {
        if (currentUnit !== null && currentUnit.status === UnitStatus.BudgetNotRequestedIgnoreDate) return true;
        if (settings !== null && settings.promotion_status === PromotionStatus.RequestBudgetEnded) return false;
        if (currentUnit !== null && (currentUnit.status === UnitStatus.BudgetRequested
            || currentUnit.status === UnitStatus.BudgetRequestInProcess)) return false;

        return currentUnit !== null && currentUnit.status === UnitStatus.BudgetNotRequested;
    };

    const getRequestBudgetError = () => {
        if (settings !== null && settings.promotion_status === PromotionStatus.RequestBudgetEnded) {
            return TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-status-finished',
                'El proceso de fomalización ha finalizado.');
        }
        if (currentUnit !== null && (currentUnit.status === UnitStatus.BudgetRequested
            || currentUnit.status === UnitStatus.BudgetRequestInProcess)) {
                return TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-status-already-formalized',
                'Esta vivienda ya ha sido formalizada. En caso de ayuda ponte en contacto con tu comercial.');
        }

        return TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-status-error-formalizing',
            'Se ha producido un error al formalizar.');
    };

    const closePopupHandler = () => {
        dispatch(setPopupState(PopupState.None));
    };

    const isRequestBudgetPopupOpened = true;

    return (
      <div className={`request-budget-popup ${isRequestBudgetPopupOpened ? ' opened' : ''}`}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`background ${isRequestBudgetPopupOpened ? 'opened' : ''}`}
          type="button"
          onClick={closePopupHandler}
        />
        <div className={`background${isRequestBudgetPopupOpened ? ' opened' : ''}`} />
        <div className={`panel${isRequestBudgetPopupOpened ? ' opened' : ''}`}>
          <div className="header">
            {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-title', 'Formalizar Presupuesto')}
          </div>
          {isBudgetRequestAvailable() ? (
            <>
              <div className="sub-header">
                {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-subtitle',
                      '¿Está seguro que desea formalizar la configuración actual?')}

              </div>
              <div className="container-buttons">
                <button
                  className="request-budget-button"
                  type="button"
                  onClick={() => {
                                    requestBudgetMutation.mutate();
                                    dispatch(requestBudget());
                                    closePopupHandler();
                                }}
                >
                  <span>
                    {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-button', 'Formalizar')}
                  </span>
                </button>
              </div>
              <div className="body">
                {TranslationUtility.GetFormattedMessageForUI('ui-request-budget-panel-footer',
                    'Al pulsar el botón recibirás un correo de confirmación y no podrás volver a formalizar.'
                    + ' En caso de ayuda ponte en contacto con tu comercial.')}

              </div>
            </>
                ) : <div className="sub-header">{getRequestBudgetError()}</div>}
          <button
            className="close-button"
            type="button"
            onClick={closePopupHandler}
          ><CloseButton />
          </button>
        </div>
      </div>
    );
};

export default RequestBudgetPopup;
